import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CustomFieldsModule } from "@webapp/custom-fields/custom-fields.module";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { TaskStatusModule } from "@webapp/okrs/components/okr-tasks/components/task-status/task-status.module";
import { ParentSelectorModule } from "@webapp/okrs/components/parent-selector/parent-selector.module";
import { SessionsModule } from "@webapp/sessions/sessions.module";
import { RichTextEditorWithMentionsModule } from "@webapp/shared/rich-text-editor-with-mentions/rich-text-editor-with-mentions.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiCheckboxModule } from "@webapp/ui/checkbox/checkbox.module";
import { UiDatePickerModule } from "@webapp/ui/date-picker/date-picker.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiInputNumberModule } from "@webapp/ui/input-number/input-number.module";
import { UiInputModule } from "@webapp/ui/input/input.module";
import { UiPopoverModule } from "@webapp/ui/popover/popover.module";
import { UiToggleModule } from "@webapp/ui/toggle/toggle.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { PeopleSelectorModule } from "../components/people-selector/people-selector.module";
import { IconWithPopoverModule } from "../icon-with-popover/icon-with-popover.module";
import { IndicatorModule } from "../indicator/indicator.module";
import { FORM_CONTENT_TEMPLATE_DECLARABLES } from "./components";
import { FORM_ITEM_DECLARABLES } from "./components/form-items";
import { FormGroupComponent } from "./form-group.component";
import { FORM_PIPES } from "./pipes";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LocalizationModule,
    IconWithPopoverModule,
    UiPopoverModule,
    UiInputModule,
    UiButtonModule,
    SessionsModule,
    PeopleSelectorModule,
    ParentSelectorModule,
    UiCheckboxModule,
    CustomFieldsModule,
    IndicatorModule,
    UiInputNumberModule,
    UiDatePickerModule,
    UiIconModule,
    RichTextEditorWithMentionsModule,
    TaskStatusModule,
    UiToggleModule,
    UiTooltipModule,
  ],
  declarations: [FormGroupComponent, ...FORM_PIPES, ...FORM_CONTENT_TEMPLATE_DECLARABLES, ...FORM_ITEM_DECLARABLES],
  exports: [FormGroupComponent, ...FORM_CONTENT_TEMPLATE_DECLARABLES, ...FORM_ITEM_DECLARABLES],
})
export class FormModule {}
